(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["trekka-sticker-pack-size"] && !Shopify.designMode) return;
  try {
    import('@shopify/events').then(({ StandardEvents }) => {
class TrekkaStickerSizes extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, async (event) => {
      if (event.target.closest('product-card, quick-add-dialog')) return;
      try {
        const { detail } = await event.promise;
        if (detail?.productId !== this.dataset.productId || !detail?.html) return;
        const updated = detail.html.getElementById(this.id);
        if (updated) this.replaceChildren(...updated.childNodes);
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller.abort(); }
}
if (!customElements.get('trekka-sticker-sizes')) customElements.define('trekka-sticker-sizes', TrekkaStickerSizes);
});
  } catch(e) { console.error(e); }
})();

})();
